import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { ENABLE_CONSUMER_MODE } from "@faire/retailer-visitor-shared/lib/consts";
import { SignUpType } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { ProductPagePaths } from "@faire/retailer-visitor-shared/paths/ProductPage";
import { Storage } from "@faire/web--source/common/Storage";
import { isPrerender } from "@faire/web--source/common/user-agent/isPrerender";
import qs from "query-string";
export var generateProductLinkPropsForLoggedOutRetailer = function(param) {
    var productToken = param.productToken, brandToken = param.brandToken, productOptionToken = param.productOptionToken, isShowRefB = param.isShowRefB, refF = param.refF, refC = param.refC, location = param.location;
    if (!productToken) {
        return undefined;
    }
    var productPageLink = ProductPagePaths.index(productToken);
    var isConsumerMode = Storage.session.getItem(ENABLE_CONSUMER_MODE) === "true";
    if (isPrerender() || isConsumerMode) {
        return {
            productUrl: productPageLink
        };
    }
    var signUpUrl = "".concat(location.pathname, "?").concat(qs.stringify(_object_spread_props(_object_spread({}, qs.parse(location.search)), {
        signUp: SignUpType.PRODUCT,
        brand: brandToken,
        product: productToken,
        productOptionToken: productOptionToken,
        refB: isShowRefB ? brandToken : undefined,
        refC: refC,
        refF: refF
    })));
    // When the product tile links to the signUpUrl, it opens a signup modal over the current page
    // by modifying the current path to append a signUp param. In this case we want to use history.replace
    // instead of history.push so that page navigatino remains intuitive.
    return {
        productUrl: signUpUrl,
        replace: true
    };
};
